const validEmailRegExp = new RegExp(/^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6})*$/);
const validNumericIntRegExp = new RegExp(/^\d+$/);
const validNumericRegExp = new RegExp(/^-?\d+([.,]\d+)?$/);

export const isValidEmail = (email: string) => {
    return validEmailRegExp.test(email);
};

export const isNumericInt = (value: string) => {
    return validNumericIntRegExp.test(value);
};

export const isNumeric = (value: string) => {
    return validNumericRegExp.test(value);
};
